import { TFunction, t } from 'i18next';
import { InputText, Text } from '@pentabd/ui';
import { IconSearch } from '@pentabd/icons';
import { numberLanguageFormatter } from '@utils/utils';
import { PresidingOfficerInfo } from './PresidingOfficerInfo';
import { CenterWiseResultsType } from '@type/centerWiseResults';

export const centerWiseResultsColumn = ({
  t,
}: {
  t: TFunction<'translation', undefined>;
}) => [
  {
    id: 1,
    name: t('CENTER_WISE_RESULTS.BODY.TABLE.COLUMN.CENTER_NAME'),
    key: 'center_name',
    render: (data: string) => <Text className="text-nowrap">{data}</Text>,
  },
  {
    id: 2,
    name: t(
      'CENTER_WISE_RESULTS.BODY.TABLE.COLUMN.CENTER_PRESIDING_OFFICER_NAME',
    ),
    key: 'presiding_officer_name',
    render: (data: any, row: CenterWiseResultsType) => (
      <div>{data ? <PresidingOfficerInfo row={row} /> : <>N/A</>}</div>
    ),
  },
  {
    id: 3,
    name: (
      <div className="header_text_align_center">
        {t('CENTER_WISE_RESULTS.BODY.TABLE.COLUMN.TOTAL_VOTE')}
      </div>
    ),
    key: 'total_voters',
    render: (data: string) => (
      <div className="d-flex justify-content-center">
        <Text className="text-nowrap">{data}</Text>
      </div>
    ),
  },
  {
    id: 4,
    name: (
      <div className="header_text_align_center">
        {t('CENTER_WISE_RESULTS.BODY.TABLE.COLUMN.VOTE_RECEIVED')}
      </div>
    ),
    key: 'votes_received',
    render: (data: string) => (
      <div className="d-flex justify-content-center">
        <Text className="text-nowrap">{data}</Text>
      </div>
    ),
  },
  {
    id: 5,
    name: (
      <div className="header_text_align_center">
        {t('CENTER_WISE_RESULTS.BODY.TABLE.COLUMN.PERCENTAGE')}
      </div>
    ),
    key: 'percentage',
    render: (data: string) => (
      <div className="d-flex justify-content-center">
        <Text className="text-nowrap">{data}</Text>
      </div>
    ),
  },
];

export function HeaderExtensionCenterWiseTable({
  isLoading,
  centerWisResults,
  handleQuery,
  query,
}: {
  isLoading: boolean;
  centerWisResults: any;
  handleQuery: (name: string, value: string | number) => void;
  query: {
    page: number;
    size: number;
    search: number | string;
    timeSlot: number | string;
    percentage: number | string;
  };
}) {
  return {
    leftComponents: [
      !isLoading ? (
        <div>
          <Text className="subtitle2 text-nowrap" weight="bold" component="p">
            {t('CENTER_WISE_RESULTS.BODY.TABLE.COLUMN.CONSTITUENCY_NAME')}:{' '}
            {centerWisResults?.asonName || ''}
          </Text>
          <Text
            className="subtitle2 text-nowrap mt-2"
            weight="bold"
            component="p"
          >
            {t('CENTER_WISE_RESULTS.BODY.TABLE.COLUMN.ZILLA_NAME')}:{' '}
            {centerWisResults?.zillaName || ''}
          </Text>
          <Text
            className="subtitle2 text-nowrap mt-2"
            weight="semibold"
            component="p"
          >
            {t('CENTER_WISE_RESULTS.BODY.TABLE.COLUMN.TOTAL_VOTE_CENTER')}:{' '}
            {numberLanguageFormatter(centerWisResults?.total || 0)}
          </Text>
        </div>
      ) : (
        <></>
      ),
    ],
    rightComponents: [
      <div className="d-flex flex-column flex-sm-row gap-8">
        <InputText
          name="percentage"
          onChange={(e) => {
            if (e.target.value) {
              const percentage = Number(e.target.value);

              if (percentage >= 0 && percentage <= 100) {
                handleQuery('percentage', percentage);
              }
            } else {
              handleQuery('percentage', '');
            }
          }}
          value={query?.percentage as string}
          prefix={<IconSearch fill="dark" size="20" />}
          size="sm"
          placeholder={t('CENTER_WISE_RESULTS.BODY.TABLE.SEARCH_BY_PERCENTAGE')}
          type="number"
          controlling
        />
        <InputText
          name="search"
          onChange={(e) => {
            handleQuery('search', e.target.value);
          }}
          value={query?.search as string}
          prefix={<IconSearch fill="dark" size="20" />}
          size="sm"
          placeholder={t('CENTER_WISE_RESULTS.BODY.TABLE.SEARCH')}
          type="text"
          controlling
        />
      </div>,
    ],
  };
}
